"use client";

import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import dynamic from "next/dynamic";
import { GoogleRecaptchaProvider } from "@repo/captcha/google";

const Modal = dynamic(() => import("@/components/Modal/Modal"), { ssr: false });
const ApplicationForm = dynamic(
  () => import("@/components/ApplicationForm/ApplicationForm"),
  { ssr: false },
);

interface ApplicationButtonProps {
  children: React.ReactNode;
  className?: string;
}

const recaptchaSiteKey = "6LfPEgIsAAAAAOEvV_JyCrGypR7AcTdTR92JJRqj";

export default function ApplicationButton({
  children,
  className,
}: ApplicationButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    setIsMounted(true);
    import("@/components/Modal/Modal");
    import("@/components/ApplicationForm/ApplicationForm");
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button ref={triggerRef} className={className} onClick={openModal}>
        {children}
      </button>
      {isMounted &&
        createPortal(
          <GoogleRecaptchaProvider siteKey={recaptchaSiteKey}>
            {isModalOpen && (
              <Modal
                isOpen={isModalOpen}
                onClose={closeModal}
                triggerElement={triggerRef.current}
              >
                {({ onClose }) => <ApplicationForm onClose={onClose} />}
              </Modal>
            )}
          </GoogleRecaptchaProvider>,
          document.body,
        )}
    </>
  );
}
